import React, { useState } from 'react';

export default function NameEntry({ onSuccess, onBack }) {
  const [nom, setNom] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nom.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/participant', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nom: nom.trim() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      onSuccess(data.participant, data.choix);
    } catch (err) {
      setError('Impossible de se connecter. Réessaie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div className="container px-3" style={{ maxWidth: 420 }}>
        {/* Back */}
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: '#607d8b', fontWeight: 700, padding: '0 0 1.5rem', cursor: 'pointer' }}>
          <i className="bi bi-arrow-left me-1" />Retour
        </button>

        {/* Card */}
        <div className="party-card p-4">
          <div className="text-center mb-4">
            <div style={{ fontSize: '3.5rem', marginBottom: '0.5rem' }}>👋</div>
            <h2 style={{ fontWeight: 800, color: '#1a2e35', fontSize: '1.5rem', marginBottom: '0.5rem' }}>
              Qui est là ?
            </h2>
            <p style={{ color: '#607d8b', fontSize: '0.95rem', margin: 0 }}>
              Entre ton prénom pour voir la liste des boissons
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="name-input"
                placeholder="Ton prénom..."
                value={nom}
                onChange={e => setNom(e.target.value)}
                autoFocus
                autoComplete="given-name"
                maxLength={50}
              />
            </div>
            {error && (
              <div className="alert alert-danger py-2 px-3 rounded-pill text-center" style={{ fontSize: '0.85rem' }}>
                {error}
              </div>
            )}
            <button
              type="submit"
              className="btn btn-party w-100"
              disabled={!nom.trim() || loading}
            >
              {loading ? (
                <><span className="spinner-border spinner-border-sm me-2" />Chargement...</>
              ) : (
                <>Voir les boissons <i className="bi bi-arrow-right ms-1" /></>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
